import styled from 'styled-components';

import useDischargeCalendarCounts from '../hooks/useDischargeCalendarCounts';
import useDischargeCalendarWeek from '../hooks/useDischargeCalendarWeek';
import useWeekNavigation from '../hooks/useWeekNavigation';
import CalendarLegend from '../shared/CalendarLegend';
import DateNavigation from '../shared/DateNavigation';
import WeekViewGrid from '../weekView/WeekViewGrid';

export default function TwoWeekView() {
  const { daysOfWeek, startDate, endDate } = useWeekNavigation({ weeks: 2 });
  const firstWeekDays = daysOfWeek.slice(0, 7);
  const secondWeekDays = daysOfWeek.slice(7);
  const { data, isFetching } = useDischargeCalendarWeek({ weeks: 2 });
  const { data: counts } = useDischargeCalendarCounts({ startDate, endDate });

  return (
    <Container>
      <Header>
        <DateNavigation weeks={2} />
        <CalendarLegend />
      </Header>
      <CalendarContainer>
        <WeekViewGrid daysOfWeek={firstWeekDays} weekData={data} counts={counts} isLoading={isFetching} noBorder />
        <WeekSeparator />
        <WeekViewGrid daysOfWeek={secondWeekDays} weekData={data} counts={counts} isLoading={isFetching} noBorder />
      </CalendarContainer>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 24px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

const CalendarContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black10};
  border-radius: 8px;
  overflow: hidden;
`;

const WeekSeparator = styled.div`
  height: 1px;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.black10};
`;
